import { render, staticRenderFns } from "./ConfigureDocTypeDocument.vue?vue&type=template&id=00d1c830&scoped=true"
import script from "./ConfigureDocTypeDocument.vue?vue&type=script&lang=js"
export * from "./ConfigureDocTypeDocument.vue?vue&type=script&lang=js"
import style0 from "./ConfigureDocTypeDocument.vue?vue&type=style&index=0&id=00d1c830&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d1c830",
  null
  
)

export default component.exports